import axios from "axios";

export function logAiToolkitError(error, label) {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      const status = error.response.status;
      const message =
        error.response.data?.message ||
        error.response.statusText ||
        "Unknown server error";
      console.error(`${label} failed (${status}): ${message}`);
    } else if (error.request) {
      console.error(`${label} failed: No response from server`);
    } else {
      console.error(`${label} request setup failed:`, error.message);
    }
  } else {
    console.error("Unexpected error:", error);
  }
}
